import { TextField, TextFieldProps, useTheme } from '@mui/material';
import { forwardRef } from 'react';

type TextInputProperties = TextFieldProps & {
  onEnter?: () => void;
};

export const TextInput = forwardRef<HTMLInputElement, TextInputProperties>(({ onEnter, ...properties }, reference) => {
  const theme = useTheme();

  return (
    <TextField
      ref={reference}
      {...properties}
      onKeyDown={event => {
        if (event.key === 'Enter') {
          onEnter?.();
        }
      }}
      variant='outlined'
      size='small'
      fullWidth
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
          '& fieldset': {
            borderColor: theme.palette.divider,
          },
          '&:hover fieldset': {
            borderColor: theme.palette.secondary.main,
          },
        },
      }}
    />
  );
});

TextInput.displayName = 'TextInput';
